<template>
  <b-modal
    id="leader-user-lookup-modal"
    size="md"
    title="กำหนดประธานโครงการ"
    ok-title="บันทึก"
    ok-variant="primary"
    cancel-title="ปิด"
    :ok-disabled="!isReadyToSave"
    @ok="submit"
    @hidden="clearForm"
  >
    <b-alert variant="primary" show>
      <font-awesome-icon icon="info-circle" /> <strong>กรอกชื่อผู้ใช้ (Username) จากระบบ <a href="https://iam.kmitl.ac.th">I-AM KMITL <font-awesome-icon icon="external-link-alt" /></a> เท่านั้น</strong> (รหัสนักศึกษา/ชื่อผู้ใช้บุคลากรสถาบัน) จากนั้นคลิกปุ่ม "ค้นหา"
    </b-alert>

    <b-row>
      <b-col cols="9">
        <b-form-group label-cols="4" label-cols-lg="2" label="ชื่อผู้ใช้">
          <b-form-input v-model="username" />
        </b-form-group>
      </b-col>
      <b-col class="pl-0">
        <b-button variant="primary" block :disabled="isBusy" @click="lookup"><font-awesome-icon icon="search" />ค้นหา</b-button>
      </b-col>
    </b-row>

    <b-alert variant="danger" :show="isNotFound">
      <font-awesome-icon icon="exclamation-triangle" /> ไม่พบผู้ใช้งานดังกล่าว กรุณาตรวจสอบการกรอกข้อมูลอีกครั้ง
    </b-alert>

    <template v-if="result">
      <hr class="mt-4">

      <div class="bt-3">
        <div class="text-center mb-2"><strong>ผลการค้นหา</strong></div>
        <div class="card">
          <div class="card-body">
            <dl class="row mb-0">
              <dt class="col-3 mb-2">ชื่อผู้ใช้</dt>
              <dd class="col-9">{{ result.username }}</dd>
              <dt class="col-3">ชื่อ (อังกฤษ)</dt>
              <dd class="col-9">{{ result.firstName }} {{ result.lastName }}</dd>
              <dt class="col-3">ชื่อ (ไทย)</dt>
              <dd class="col-9">
                <template v-if="!isProfileEdit">
                  <template v-if="result.thFirstName">{{ result.thFirstName }} {{ result.thLastName }}</template>
                  <template v-else><em class="text-muted">- ไม่มีข้อมูล -</em></template>
                  <a href="#" class="float-right" @click.prevent="enableProfileEdit">แก้ไข</a>
                </template>
                <template v-else>
                  <input v-model="leaderForm.name" type="text" class="form-control">
                </template>
              </dd>
              <dt class="col-3">โทรศัพท์</dt>
              <dd class="col-9">
                <template v-if="!isProfileEdit">
                  <template v-if="result.tel">{{ result.tel }}</template>
                  <template v-else><em class="text-muted">- ไม่มีข้อมูล -</em></template>
                  <a href="#" class="float-right" @click.prevent="enableProfileEdit">แก้ไข</a>
                </template>
                <template v-else>
                  <input v-model="leaderForm.tel" type="text" class="form-control">
                </template>
              </dd>
            </dl>
          </div>
        </div>
      </div>
      <template v-if="!result.tel || !result.thFirstName">
        <b-alert variant="warning" class="mt-2" show>
          <font-awesome-icon icon="info-circle" />กรุณากรอกชื่อภาษาไทย และหมายเลขโทรศัพท์ก่อนบันทึกข้อมูล
        </b-alert>
      </template>
    </template>
  </b-modal>
</template>

<script>
import USER_LOOKUP_QUERY from '@/graphql/queries/userLookup.gql'

export default {
  data: () => ({
    username: '',
    result: null,
    isNotFound: false,
    isReadyToSave: false,
    leaderForm: {
      name: '',
      tel: '',
      username: ''
    },
    isProfileEdit: false,
    isBusy: false
  }),
  methods: {
    async lookup () {
      this.isBusy = true
      this.isProfileEdit = false
      this.isReadyToSave = false
      this.result = null
      this.isNotFound = false

      try {
        let result = await this.$apollo.query({
          query: USER_LOOKUP_QUERY,
          variables: {
            username: this.username
          },
          fetchPolicy: 'no-cache'
        })

        result = result.data.userLookup

        if (!result) {
          this.isNotFound = true
          return
        }

        this.result = result
        this.leaderForm = {
          name: result.thFirstName ? `${result.thFirstName} ${result.thLastName}` : `${result.firstName} ${result.lastName}`,
          tel: result.tel,
          username: result.username
        }

        this.isReadyToSave = true
      } catch (_) {
        this.isNotFound = true
      } finally {
        this.isBusy = false
      }
    },
    enableProfileEdit () {
      this.isProfileEdit = true
    },
    async submit () {
      await this.$store.dispatch('project/setHeadOfProject', {
        id: this.$route.params.id,
        payload: this.leaderForm
      })
    },
    clearForm () {
      this.username = ''
      this.result = null
      this.isNotFound = false
      this.isReadyToSave = false
      this.leaderForm = {
        name: '',
        tel: '',
        username: ''
      }
      this.isProfileEdit = false
      this.isBusy = false
    }
  }
}
</script>
